import http from './Http';
import Service from './Service';

/**
 * @type ProviderService
 */
export default class ProviderService extends Service {

    list( quotationId ) {
        return http.get(
            'getfornecedoresprodutofiltro', {
                headers: this.getHeaders(),
                timeout: 1200000,
                params: {
                numeroCotacao: quotationId
                }
            }
        );
    }

    get_evaluation(seller_id) {
        return http.get(
            'getavaliacaovendedor', {
                headers: this.getHeaders(),
                timeout: 1200000,
                params: {
                    id_vendedor: seller_id
                }
            }
        );
    }

    remove_seller(seller_id) {
        return http.delete(
            `providers/${seller_id}`, {
                headers: this.getHeaders()
            }
        );
    }

}
